import { App } from "@capacitor/app";
import { isNative } from "./capacitor";

/** Subscribe to the Android hardware back button; returns an unsubscribe. No-op on the web and on iOS. */
export function listenForBackButton(onBack: () => void): () => void {
  if (!isNative()) return () => {};
  const sub = App.addListener("backButton", () => {
    // Registering a listener replaces Capacitor's default back handling, so a
    // throw here would leave the button doing nothing at all.
    try {
      onBack();
    } catch {
      /* ignore */
    }
  });
  return () => {
    void sub.then((s) => s.remove());
  };
}

/** Close the topmost open Radix overlay, if any. Returns true when one was closed. */
export function closeTopOverlay(): boolean {
  if (typeof document === "undefined") return false;
  // Dialogs and sheets are opened from local component state (e.g. PbDialog via
  // DistancePerformanceGrid), so the router knows nothing about them — back has
  // to dismiss the overlay before it touches history.
  const open = document.querySelector('[role="dialog"][data-state="open"],[role="menu"][data-state="open"]');
  if (!open) return false;
  document.dispatchEvent(new KeyboardEvent("keydown", { key: "Escape", bubbles: true }));
  return true;
}

/** Quit the app (Android back from the root). No-op on the web. */
export function exitApp(): void {
  if (!isNative()) return;
  void App.exitApp();
}
